import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de sustitución 
 * de demanda
 */
class SustitucionDemandaRequest {
    /**
     * Llamada el endpoint de django para listar 
     * las sustituciones de la bd
     * @param: value. id del sitio
     * @param: data. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static ListarSustitucionDemanda(value) {
        return middleware.hasAuth(() => request.get(`api/situaciones-demanda/`, {
            params: {
                sitio: value
            }
        }));
    }

    /**
     * Llamada el endpoint de django para crear una sustitucion
     * @param: data. objeto con información de la sustitucion
     * @return: Mensaje de éxito o error.
     */
    static NuevaSustitucionDemanda(data) {
        return middleware.hasAuth(() => request.post(`api/situaciones-demanda/`, data));
    }

    /**
     * Llamada el endpoint de django para editar una sustitucion
     * @param: value. id de la sustitucion
     * @param: data. objeto con información de la sustitucion
     * @return: Mensaje de éxito o error.
     */
    static EditarSustitucionDemanda(data) {
        return middleware.hasAuth(() => request.put(`api/situaciones-demanda/update/${data?.id}`, data));
    }

    /**
     * Llamada el endpoint de django para eliminar sustitución
     * @param: value. id de la sustitución
     * @return: Mensaje de éxito o error.
     */
    static EliminarSustitucion(value) {
        return middleware.hasAuth(() => request.put(`api/situaciones-demanda/delete/${value}/`));
    }

}

export default SustitucionDemandaRequest;